// @copyright  2006 - 2024 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'manufacturing-order.page.title': 'Manufacturing Orders',
    'manufacturing-order.page.search_results': 'Search Results',
    'manufacturing-order.page.create.title': 'New Manufacturing Order',
    'manufacturing-order.page.search.title': 'Find Manufacturing Orders',
    'manufacturing-order.page.all': 'All',

    'manufacturing-order.button.cancel': 'Cancel',
    'manufacturing-order.button.select': 'Select',
    'manufacturing-order.button.find': 'Find Manufacturing Orders',
    'manufacturing-order.button.search': 'Apply',
    'manufacturing-order.button.create': 'Create Manufacturing Order',
    'manufacturing-order.button.new': 'New Manufacturing Order',
    'manufacturing-order.button.start': 'Start Production',
    'manufacturing-order.button.complete': 'Complete Production',
    'manufacturing-order.button.cancel_order': 'Cancel Order',
    'manufacturing-order.button.reset': 'Reset',
    'manufacturing-order.button.back': 'Back',

    'manufacturing-order.placeholder.search': 'Search Manufacturing Orders',

    'manufacturing-order.link.create_first_manufacturing_order': 'Click here to create your first manufacturing order',
    'manufacturing-order.link.manufacturing_orders': 'Return to Manufacturing Orders',
    'manufacturing-order.link.retry': 'Click here to retry',

    'manufacturing-order.label.manufacturing_order_number': 'MO Number',
    'manufacturing-order.label.bill_of_material_id': 'Bill of Material',
    'manufacturing-order.label.output_inventory_id': 'Output Product',
    'manufacturing-order.label.quantity_to_produce': 'Qty to Produce',
    'manufacturing-order.label.quantity_produced': 'Qty Produced',
    'manufacturing-order.label.quantity_scrapped': 'Qty Scrapped',
    'manufacturing-order.label.order_date': 'Order Date',
    'manufacturing-order.label.planned_start_date': 'Planned Start',
    'manufacturing-order.label.planned_end_date': 'Planned End',
    'manufacturing-order.label.actual_start_date': 'Actual Start',
    'manufacturing-order.label.actual_end_date': 'Actual End',
    'manufacturing-order.label.manufacturing_order_status': 'Status',
    'manufacturing-order.label.currency_estimated_cost': 'Estimated Cost',
    'manufacturing-order.label.currency_actual_cost': 'Actual Cost',
    'manufacturing-order.label.notes': 'Notes',
    'manufacturing-order.label.component': 'Component',
    'manufacturing-order.label.quantity_required': 'Qty Required',
    'manufacturing-order.label.quantity_consumed': 'Qty Consumed',
    'manufacturing-order.label.currency_unit_cost': 'Unit Cost',
    'manufacturing-order.label.currency_total_cost': 'Total Cost',
    'manufacturing-order.label.components': 'Components',

    'manufacturing-order.sort.field_label': 'Field',
    'manufacturing-order.sort.direction_label': 'Direction',
    'manufacturing-order.sort.direction_ascending': 'Ascending',
    'manufacturing-order.sort.direction_descending': 'Descending',

    'manufacturing-order.status.draft': 'Draft',
    'manufacturing-order.status.in_progress': 'In Progress',
    'manufacturing-order.status.completed': 'Completed',
    'manufacturing-order.status.cancelled': 'Cancelled',

    'manufacturing-order.modal.title.start_order': 'Start Manufacturing Order',
    'manufacturing-order.modal.message.start_order': 'Are you sure you want to start production for this order?',
    'manufacturing-order.modal.title.complete_order': 'Complete Manufacturing Order',
    'manufacturing-order.modal.message.complete_order': 'Enter the quantity produced to complete this order.',
    'manufacturing-order.modal.title.cancel_order': 'Cancel Manufacturing Order',
    'manufacturing-order.modal.message.cancel_order': 'Are you sure you want to cancel this manufacturing order?',

    'manufacturing-order.button.record_scrap': 'Record Scrap',

    'manufacturing-order.label.adjustment_reason': 'Reason',

    'manufacturing-order.modal.title.record_scrap': 'Record Manufacturing Scrap',
    'manufacturing-order.modal.message.record_scrap': 'Enter scrap quantities for each component.',

    'manufacturing-order.success.message.manufacturing_order_created': 'Your manufacturing order has been created',
    'manufacturing-order.success.message.manufacturing_order_started': 'Manufacturing order has been started',
    'manufacturing-order.success.message.manufacturing_order_completed': 'Manufacturing order has been completed',
    'manufacturing-order.success.message.manufacturing_order_cancelled': 'Manufacturing order has been cancelled',
    'manufacturing-order.success.message.scrap_recorded': 'Scrap has been recorded',

    'manufacturing-order.error.message.no_scrap_entered': 'Please enter at least one scrap quantity',
    'manufacturing-order.error.message.error_loading_page': 'Sorry, there was an error loading manufacturing order.| Sorry, there was an error loading manufacturing orders.',
    'manufacturing-order.error.message.scrap_without_cost_layers': "This component has fewer costed units than you are scrapping, so the write-off cannot be valued. Review the item's purchase history before recording the scrap.",
    'manufacturing-order.error.message.scrap_write_off_account_missing': 'No manufacturing scrap or spoilage account is set up, so the write-off cannot be posted. Ask an administrator to review the chart of accounts.',
    'manufacturing-order.error.message.scrap_asset_account_missing': 'This component has no inventory asset account, so the write-off cannot be posted. Ask an administrator to review the item.',
    'manufacturing-order.error.message.start_not_draft': "Only a draft order can be started. Refresh the page to see the order's current status.",
    'manufacturing-order.error.message.already_cancelled': 'This order has already been cancelled. Refresh the page to see its current status.',
    'manufacturing-order.error.message.cannot_cancel_completed': 'A completed order cannot be cancelled, because its stock movements and journal have already been posted. Raise a new order, or scrap the finished stock, instead.',
    'manufacturing-order.error.message.scrap_not_in_progress': 'Scrap can only be recorded once an order has been started. Start the order first, then record the scrap.',
    'manufacturing-order.error.message.complete_not_in_progress': "Only an order that is in progress can be completed. Refresh the page to see the order's current status.",
    'manufacturing-order.error.message.complete_without_cost_layers': 'One of the components has no costed stock to consume, so the order cannot be valued. Receive the component on a purchase order before completing this order.',
    'manufacturing-order.error.message.complete_output_asset_account_missing': 'The finished item has no inventory asset account, so the completion cannot be posted to the ledger. Ask an administrator to set one on the item.',
    'manufacturing-order.error.message.complete_component_asset_account_missing': 'One of the components has no inventory asset account, so the completion cannot be posted to the ledger. Ask an administrator to set one on the item.',
};
